import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import TablaNominasCreate from "./TablaNominasCreate";
import { Button, Row, Label, Input, Table, Col, Spinner,  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter, } from "reactstrap";
import axios from "axios";
import ExportJsonExcel from "js-export-excel";
import Swal from "sweetalert2";
import SweetAlert from "sweetalert2-react";

function NominasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_NOMINAS = process.env.REACT_APP_URL_NOMINAS;
  const URL_FALTAS = process.env.REACT_APP_URL_FALTAS_COLABORADORES;
  const URL_PLANTELES = process.env.REACT_APP_URL_PLANTELES;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const PLANTELES_GENERAL = process.env.REACT_APP_PLANTELES_GENERAL;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const [planteles, setPlanteles] = useState([]);
  const [selectedPlantel, setSelectedPlantel] = useState("");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [comentarios, setComentarios] = useState([]);
  const [frecuencia, setFrecuencia] = useState("");
  const [fecha, setFecha] = useState("");
  // Periodo que se está pagando: se usa para contar las faltas a descontar.
  const [periodoInicio, setPeriodoInicio] = useState("");
  const [periodoFin, setPeriodoFin] = useState("");
  // { idColaborador: diasNoJustificados }
  const [faltasPorColaborador, setFaltasPorColaborador] = useState({});
  const [text, setText] = useState(false);
  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  useEffect(() => {
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        // setColaboradores(allColaboradores);
        let arrayTabla = allColaboradores
        .sort((a, b) => (a.idOrdenCompra > b.idOrdenCompra ? 1 : -1))
        .map((a) => {
          return {
            _id:a._id,
            nombre:a.nombre + " " + a.apellido,
            puesto:a.puestos[0].name,
            sueldo_actual:a.sueldo_actual,
            banco: a.banco || "",
            clabe: a.clabe || "",
            titularCuenta: a.titularCuenta || "",
            comentarios:"na",
            is_active: a.is_active,
            planteles: a.planteles[0]._id,
            areas: a.areas[0]._id,
            areasName: a.areas[0].name,
            frecuencia: a.frecuencia,
            // Ajuste de este pago: bono (+) o descuento/préstamo (−), con concepto
            ajuste: "",
            conceptoAjuste: "",
          };
        }).filter(function (el) {
          return el != null;
        });
    
        let dataFinal = Object.values(arrayTabla);
        setColaboradores(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_PLANTELES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allPlanteles = response.data;
        setPlanteles(allPlanteles);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [user]);

  let SP = 0;
  let SA = 0;

  const pagarNominas = (event) => {
    event.preventDefault();
    if(fecha !=""){
    if (user.planteles == PLANTELES_GENERAL && user.areas == AREAS_GENERAL) {
      SP = selectedPlantel;
      SA = selectedArea;
    } else {
      SA = user.areas;
      SP = user.planteles;
    }
    const incluidos = colaboradores.filter((n) => enNomina(n, SP, SA));
    const sinConcepto = incluidos.filter(
      (n) => ajusteDe(n) !== 0 && !String(n.conceptoAjuste || "").trim()
    );
    if (sinConcepto.length) {
      Swal.fire({
        icon: "error",
        title: "Falta el concepto del ajuste",
        html: "Escribe el concepto del ajuste de:<br/><b>" + sinConcepto.map((n) => n.nombre).join("<br/>") + "</b>",
      });
      return;
    }
    const negativos = incluidos.filter((n) => aPagar(n) < 0);
    if (negativos.length) {
      Swal.fire({
        icon: "error",
        title: "Pago negativo",
        html:
          "El descuento deja el pago en negativo para:<br/><b>" +
          negativos.map((n) => n.nombre).join("<br/>") +
          "</b><br/><br/>El descuento no puede ser mayor que el sueldo del periodo.",
      });
      return;
    }
    Swal.fire({
      title: "Estas seguro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Crear Nomina!",
    }).then((result) => {
      if (result.isConfirmed) {
        toggleProgreso();
        let totalGenerarCargos = colaboradores.length;
        colaboradores.map((n) => {
          if (
            n.is_active == "Si" &&
            (SP == 0 || SP == n.planteles) &&
            (SA == 0 || SA == n.areas) &&
            (frecuencia == 0 || frecuencia == n.frecuencia)
          ) {
            axios
              .post(
                URL_NOMINAS,
                {
                  fecha,
                  pagado: "No",
                  importe: Number(aPagar(n).toFixed(2)),
                  sueldoBase: Number(n.sueldo_actual || 0),
                  faltas: Number(faltasPorColaborador[String(n._id)] || 0),
                  descuentoFaltas: Number((Number(n.sueldo_actual || 0) - sueldoNeto(n)).toFixed(2)),
                  ajuste: ajusteDe(n),
                  conceptoAjuste: ajusteDe(n) !== 0 ? String(n.conceptoAjuste).trim() : "",
                  colaboradores: n._id,
                  comentarios: n.comentarios || "na",
                  planteles: n.planteles,
                  areas: n.areas,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalGenerarCargos = totalGenerarCargos - 1;
                if (totalGenerarCargos == 0) {
                  axios.post(
                    URL_LOGS,
                    {
                      tipo: "Crear Nomina",
                      detalle: `Fecha: ${fecha}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  );
                  Swal.fire("Good job!", "Creado con exito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 2000);
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          } else {
            totalGenerarCargos = totalGenerarCargos - 1;
          }
        });
      }
    })
  } else {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Selecciona una fecha",
    });
  }
  };


  // Faltas del periodo. Se cuentan sólo las NO justificadas: son las que se
  // descuentan. El periodo lo define el usuario porque la nómina se paga por
  // semana, quincena o mes según el colaborador.
  useEffect(() => {
    if (!periodoInicio || !periodoFin) {
      setFaltasPorColaborador({});
      return;
    }
    axios
      .get(`${URL_FALTAS}Fechas/${periodoInicio}/${periodoFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        const conteo = {};
        (response.data || []).forEach((f) => {
          if (f.justificada === "Si") return;
          const id = f?.colaboradores?.[0]?._id || f?.colaboradores?.[0];
          if (!id) return;
          conteo[String(id)] = (conteo[String(id)] || 0) + 1;
        });
        setFaltasPorColaborador(conteo);
      })
      .catch((err) => {
        console.log(err);
        setFaltasPorColaborador({});
      });
  }, [periodoInicio, periodoFin]);

  // Días que cubre cada frecuencia de pago, para sacar el sueldo diario.
  const diasDelPeriodo = (frec) =>
    frec === "Semanal" ? 7 : frec === "Mensual" ? 30 : 15;

  // Sueldo del periodo ya con las faltas descontadas.
  const sueldoNeto = (n) => {
    const bruto = Number(n.sueldo_actual || 0);
    const dias = Number(faltasPorColaborador[String(n._id)] || 0);
    if (!dias) return bruto;
    const diario = bruto / diasDelPeriodo(n.frecuencia);
    return Math.max(0, bruto - diario * dias);
  };

  // Lo que realmente se paga: sueldo con faltas descontadas + ajuste manual
  const ajusteDe = (n) => Number(n.ajuste) || 0;
  const aPagar = (n) => sueldoNeto(n) + ajusteDe(n);

  // Los cambios por renglón se guardan con una copia nueva del arreglo para
  // que la tabla se vuelva a pintar (el "A Pagar" cambia con el ajuste).
  const cambiaRenglon = (index, cambios) =>
    setColaboradores((prev) => prev.map((c, i) => (i === index ? { ...c, ...cambios } : c)));

  // Colaboradores que entran en esta nómina, con los filtros de pantalla
  const enNomina = (n, SPx, SAx) =>
    n.is_active == "Si" &&
    (SPx == 0 || SPx == n.planteles) &&
    (SAx == 0 || SAx == n.areas) &&
    (frecuencia == 0 || frecuencia == n.frecuencia);

  /**
   * Layout para mandar a pagar al banco: nombre, banco, CLABE e importe neto.
   * Sale con los mismos filtros de plantel/área/frecuencia que se ven en la
   * tabla, para que lo que se manda a pagar sea exactamente lo que se está
   * revisando en pantalla.
   */
  function layoutBanco() {
    const visibles = colaboradores.filter(
      (n) =>
        n.is_active === "Si" &&
        (user.planteles == PLANTELES_GENERAL && user.areas == AREAS_GENERAL
          ? (selectedPlantel == 0 || selectedPlantel == n.planteles) &&
            (selectedArea == 0 || selectedArea == n.areas)
          : user.planteles == n.planteles && user.areas == n.areas) &&
        (frecuencia == 0 || frecuencia == n.frecuencia)
    );

    if (!visibles.length) {
      Swal.fire({
        icon: "warning",
        title: "Sin colaboradores",
        text: "Los filtros actuales no dejan a nadie en la lista",
      });
      return;
    }

    const sinDatos = visibles.filter((n) => !n.banco || !n.clabe);
    const data = visibles.map((n) => ({
      Nombre: n.nombre,
      Puesto: n.puesto,
      Area: n.areasName,
      Banco: n.banco || "",
      CLABE: n.clabe || "",
      Titular: n.titularCuenta || "",
      SueldoBase: Number(n.sueldo_actual || 0),
      Faltas: Number(faltasPorColaborador[String(n._id)] || 0),
      Ajuste: ajusteDe(n),
      Concepto: ajusteDe(n) !== 0 ? n.conceptoAjuste || "" : "",
      Importe: Number(aPagar(n).toFixed(2)),
    }));
    data.push({
      Nombre: "",
      Puesto: "",
      Area: "",
      Banco: "",
      CLABE: "",
      Titular: "TOTAL",
      SueldoBase: visibles.reduce((t, n) => t + Number(n.sueldo_actual || 0), 0),
      Faltas: visibles.reduce(
        (t, n) => t + Number(faltasPorColaborador[String(n._id)] || 0),
        0
      ),
      Ajuste: visibles.reduce((t, n) => t + ajusteDe(n), 0),
      Concepto: "",
      Importe: Number(
        visibles.reduce((t, n) => t + aPagar(n), 0).toFixed(2)
      ),
    });

    const columnas = [
      "Nombre", "Puesto", "Area", "Banco", "CLABE", "Titular",
      "SueldoBase", "Faltas", "Ajuste", "Concepto", "Importe",
    ];
    new ExportJsonExcel({
      fileName: `LayoutBanco-${fecha || "nomina"}`,
      datas: [
        {
          sheetData: data,
          sheetName: "LayoutBanco",
          sheetFilter: columnas,
          sheetHeader: [
            "Nombre", "Puesto", "Area", "Banco", "CLABE", "Titular de la cuenta",
            "Sueldo base", "Faltas", "Ajuste", "Concepto ajuste", "Importe a pagar",
          ],
        },
      ],
    }).saveExcel();

    // Avisar de los que no se pueden dispersar: sin banco o sin CLABE el
    // banco rechaza el renglón, y es mejor verlo antes de mandarlo.
    if (sinDatos.length) {
      Swal.fire({
        icon: "warning",
        title: "Faltan datos bancarios",
        html:
          "Estos colaboradores salen sin banco o sin CLABE:<br/><b>" +
          sinDatos.map((n) => n.nombre).join("<br/>") +
          "</b>",
      });
    }
  }

  function sueldoModificado(nuevoSueldo, index, sueldoActual) {
    if (nuevoSueldo) cambiaRenglon(index, { sueldo_actual: parseFloat(nuevoSueldo) });
  }

  function notas(comentarios, index) {
    cambiaRenglon(index, { comentarios: comentarios || "na" });
  }

  return (
    <>
      <Header />
      <br />
      {user.nominas_create ? (
        <div className="card container col-sm-10">
          <br />
          <Row>
            <Button
              size="sm"
              type="submit"
              className="btn btn-success"
              onClick={pagarNominas}
            >
              Generar Nomina
            </Button>
            <div>
              <SweetAlert
                show={text}
                title="Creado con Exito"
                onConfirm={() => {
                  setText(false);
                }}
              />
            </div>
            <Button
              size="sm"
              href="/Nominas"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Row>
          <h3 align="center">Crear Nominas</h3>
          <Row>
            <Col md={2}>
              <Label>Fecha </Label>
              <Input
                bsSize="sm"
                type="date"
                placeholder="Fecha de Ingreso"
                value={fecha}
                required
                onChange={(e) => {
                  setFecha(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Periodo Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={periodoInicio}
                onChange={(e) => setPeriodoInicio(e.target.value)}
              />
            </Col>
            <Col md={2}>
              <Label>Periodo Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={periodoFin}
                onChange={(e) => setPeriodoFin(e.target.value)}
              />
            </Col>
            <Col md={2}>
              <Label>Frecuencia</Label>
              <Input
                bsSize="sm"
                type="select"
                placeholder="Frecuencia"
                value={frecuencia}
                required
                onChange={(e) => {
                  setFrecuencia(e.target.value);
                }}
              >
                <option value="0">Frecuencia</option>
                <option value="Semanal">Semanal</option>
                <option value="Quincenal">Quincenal</option>
                <option value="Mensual">Mensual</option>
              </Input>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <br />
              <Button size="sm" color="success" onClick={layoutBanco}>
                Layout para el banco <i className="far fa-file-excel"></i>
              </Button>
              {" "}
              {periodoInicio && periodoFin ? (
                <span style={{ fontSize: 12, color: "#666" }}>
                  Faltas descontadas del {periodoInicio} al {periodoFin}
                </span>
              ) : (
                <span style={{ fontSize: 12, color: "#b8860b" }}>
                  Captura el periodo para descontar faltas
                </span>
              )}
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <thead>
              <tr>
                <th style={{ paddingBottom: "0px" }}>Nombre</th>
                {/* <th style={{ paddingBottom: "0px" }}>Plantel</th>*/}
                <th style={{ paddingBottom: "0px" }}>Area</th> 
                <th style={{ paddingBottom: "0px" }}>Puesto</th>
                <th style={{ paddingBottom: "0px" }}>Sueldo Base</th>
                <th style={{ paddingBottom: "0px" }}>Faltas</th>
                <th style={{ paddingBottom: "0px" }}>Ajuste (+/−)</th>
                <th style={{ paddingBottom: "0px" }}>Concepto ajuste</th>
                <th style={{ paddingBottom: "0px" }}>A Pagar</th>
                <th style={{ paddingBottom: "0px" }}>Banco</th>
                <th style={{ paddingBottom: "0px" }}>CLABE</th>
                <th style={{ paddingBottom: "0px" }}>Titular</th>
                <th style={{ paddingBottom: "0px" }}>Editar Importe</th>
                <th style={{ paddingBottom: "0px" }}>Comentarios</th>
              </tr>
              <tr>
               {/*  <td></td>
                {user.planteles == PLANTELES_GENERAL ? (
                  <td style={{ paddingTop: "0px" }}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedPlantel}
                      onChange={(e) => setSelectedPlantel(e.target.value)}
                    >
                      <option value="0">Selecciona</option>
                      {planteles
                        .sort((a, b) => a.name - b.name)
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </td>
                ) : (
                  <td></td>
                )}*/}
                <td></td>
                {user.areas == AREAS_GENERAL ? (
                  <td style={{ paddingTop: "0px" }}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedArea}
                      onChange={(e) => setSelectedArea(e.target.value)}
                    >
                      <option value="0">Selecciona</option>
                      {areas
                        .sort((a, b) => a.name - b.name)
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </td>
                ) : (
                  <td></td>
                )}
              </tr> 
            </thead>
            <tbody>
              {user.planteles == PLANTELES_GENERAL &&
              user.areas == AREAS_GENERAL
                ? colaboradores.map((n, index) => {
                    if (
                      n.is_active == "Si" &&
                      (selectedPlantel == 0 ||
                        selectedPlantel == n.planteles) &&
                      (selectedArea == 0 || selectedArea == n.areas) &&
                      (frecuencia == 0 || frecuencia == n.frecuencia)
                    ) {
                      return (
                        <tr>
                          <TablaNominasCreate
                            nombre={n.nombre}
                            // plantel={n.planteles[0].name}
                            area={n.areasName}
                            puesto={n.puesto}
                            importe={n.sueldo_actual}
                            id={n._id}
                            key={n._id}
                            index={index}
                            faltas={faltasPorColaborador[String(n._id)] || 0}
                            neto={aPagar(n)}
                            ajuste={n.ajuste}
                            conceptoAjuste={n.conceptoAjuste}
                            onAjuste={(v) => cambiaRenglon(index, { ajuste: v })}
                            onConceptoAjuste={(v) => cambiaRenglon(index, { conceptoAjuste: v })}
                            banco={n.banco}
                            clabe={n.clabe}
                            titularCuenta={n.titularCuenta}
                            sueldoModificado={sueldoModificado}
                            comentarios={notas}
                          />
                        </tr>
                      );
                    }
                  })
                : colaboradores.map((n, index) => {
                    if (
                      n.is_active == "Si" &&
                      user.planteles == n.planteles &&
                      user.areas == n.areas &&
                      (frecuencia == 0 || frecuencia == n.frecuencia)
                    ) {
                      return (
                        <tr>
                           <TablaNominasCreate
                            nombre={n.nombre}
                            // plantel={n.planteles[0].name}
                            area={n.areasName}
                            puesto={n.puesto}
                            importe={n.importe}
                            id={n._id}
                            key={n._id}
                            index={index}
                            faltas={faltasPorColaborador[String(n._id)] || 0}
                            neto={aPagar(n)}
                            ajuste={n.ajuste}
                            conceptoAjuste={n.conceptoAjuste}
                            onAjuste={(v) => cambiaRenglon(index, { ajuste: v })}
                            onConceptoAjuste={(v) => cambiaRenglon(index, { conceptoAjuste: v })}
                            banco={n.banco}
                            clabe={n.clabe}
                            titularCuenta={n.titularCuenta}
                            sueldoModificado={sueldoModificado}
                            comentarios={notas}
                          />
                        </tr>
                      );
                    }
                  })}
            </tbody>
          </Table>{" "}
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
             <h4> Este proceso puede tardar varios segundos.
              <br />
              Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
      
    </>
  );
}
export default NominasCreate;
